/**
 * ueditorForManuscript 广电广电文稿编辑器
 * author Qian.qianchen 2019-04-04
 */
'use strict';
angular.module('util.ueditorForManuscript', [
    'util.ueditorConfig',
    'util.ueditorServiceModule',
    'eyeProtectionModelModule',
    'ueditorPlugInModule',
    'ueditorForManuscriptBtnServiceModule',
]).directive('ueditorForManuscript', ['$timeout', 'ueditorForManuscriptBtnService', '$sce', '$q', '$modal', '$interval', 'localStorageService', 'trsUeditorConfigService', 'modalDialog', 'ueditorService', '$compile', '$window', '$stateParams', 'ueditorPlugIn', function ($timeout, ueditorForManuscriptBtnService, $sce, $q, $modal, $interval, localStorageService, trsUeditorConfigService, modalDialog, ueditorService, $compile, $window, $stateParams, ueditorPlugIn) {
    return {
        restrict: 'E',
        scope: {
            list: '=',
            type: '@',
            versionid: '=',
            infullscreen: '=', // 是否处在全屏状态
            metadataid: '=',
            draftType: '@', // 稿件类型
            hasContent: '=', // 编辑器内是否有内容
            speed: '@',
            editFlag: '=',
        },
        replace: true,
        // templateUrl: './lib/ueditor/ueditor.html',
        template: "<div type='_manuscript'><script id='ueditor' style='width:100%;position:relative'></script><div class='trs_ueditor_selectionNum'></div></div>",
        link: function (scope, element, attrs, ctrl) {
            ueditorService.rewriteAutotypesetCache(UE);
            /* require(['./lib/ueditor2/ueditor.config', './lib/ueditor2/ueditor.all'], function() {*/
            var tempArrary = [];
            var editorToolBar = ueditorService.getToolBar();
            var indexArray = [4, 5, 6, 7, 8, 18, 17, 29, 27, 28, 31, 343, 33, 34, 35, 36, 37, 38, 39, 40, 41, 42, 48, 45, 46, 47];
            editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], indexArray);
            // if (angular.isUndefined(scope.type)) { //采编中心i我渠道剔除一些按键功能
            //     editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], [33]);
            // }
            // if (typeof scope.type === "string" && scope.type.indexOf("newsPaper") >= 0) { //采编中心报纸渠道剔除一些按键功能
            //     editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], [35, 34, 33, 32]);
            //     editorToolBar.labelMap.allowCopyImg = false;
            //     editorToolBar.pasteplain = true;
            //     //字数统计浮标
            // }
            // if (scope.type === "weixin") { //采编中心微信渠道剔除一些按键功能
            //     var indexArray = [45, 44, 40, 39, 38, 37, 36, 33, 32, 31, 27, 26, 9, 8, 7, 6, 5, 4, 3];
            //     editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], indexArray);
            //     editorToolBar.pasteplain = false;
            // }
            // if (scope.type === "website") {
            //     var indexArray = [33];
            //     editorToolBar.toolbars[0] = ueditorService.removeToolBarFunction(editorToolBar.toolbars[0], indexArray);
            // }
            var ue = UE.getEditor('ueditor', editorToolBar);
            var domUtils = baidu.editor.dom.domUtils;
            ue.ready(function () {
                // scope.list.HTMLCONTENT = ueditorService.replaceHtmlBlank(scope.list.HTMLCONTENT); //将半角空格换为全角空格
                scope.list.HTMLCONTENT = scope.list.HTMLCONTENT.replace(/<trs_page_separator pagetitle="" firstpagetitle=""><\/trs_page_separator>/g, '<hr ispageseparator="true"/>'); // 替换分页符标签，用于编辑器展示
                ue.setContent(scope.list.HTMLCONTENT);
                // 纯文本正文及字数
                var preContent = ueditorService.getTextContent(ue.getContentTxt());
                scope.list.DOCWORDSCOUNT = preContent
                    .replace(/\n/g, '')
                    .replace(/\u0020/g, '')
                    .replace(/\u3000/g, '').length; // 兼容大数据取稿字数算法不同问题
                // 纯文本正文及字数
                var preResult = $sce.getTrustedHtml("<div class='display_none ueditorWordCount'>已输入<span class='color-red'>{{list.DOCWORDSCOUNT}}</span>个字</div>");
                var result = $compile(preResult)(scope);
                // element.find('.edui-editor').append(result);
                element.find('.edui-editor-toolbarboxinner').append(result);
                var destroyWatch = scope.$watch('list.DOCWORDSCOUNT', function (newValue) {
                    if (newValue) {
                        $timeout(function () {
                            result.removeClass('display_none');
                            destroyWatch();
                        });

                    }
                });
                ue.getOpt('lang');
                // ue.setHeight(500);
                var promise_keyup;
                var promise_contentChange;
                var promise_mouseup;
                ue.addListener('keyup', function () { // 实时双向绑定开始
                    bindContent(promise_keyup);
                });
                ue.addListener('contentChange', function () { // 实时双向绑定开始
                    bindContent(promise_contentChange);
                    // 编辑器的必填提示
                    $timeout(function () {
                        var content = ue.getContent();
                        if (content !== '') {
                            scope.hasContent = true;
                        } else {
                            scope.hasContent = false;
                        }
                    });
                });
                // 计算显示字数，并显示出来
                domUtils.on(ue.body, 'mouseup', function (event) {
                    selectionNumPop(event);
                });
                domUtils.on(ue.body, 'keydown', function (event) {
                    selectionNumPop(event);
                    timeCalc(); // 自动计算时间
                });
                // 显示选中区域的字数
                ue.addListener('selectionchange', function () {
                    // 查看痕迹后或进入源码模式下禁用编辑器按钮
                    if (this.body.contentEditable == 'false' || this.sourceMode === true) {
                        for (var k in ueditorBtn) {
                            if (ueditorBtn[k] !== '') {
                                ueditorBtn[k].addState('disabled');
                            }
                        }
                    } else {
                        for (var j in ueditorBtn) {
                            if (ueditorBtn[j] !== '') {
                                ueditorBtn[j].removeState('disabled');
                            }
                        }
                    }
                    var selectionStr = this.selection.getText();
                    if (selectionStr.length === 0) {
                        hideSelectionNum();
                    }
                });
                // 编辑器失焦是字数显示消失
                ue.addListener('blur', function () {
                    hideSelectionNum();
                });
                insertCommonContent();

                /**
                 * [showSelectionNum methodname]显示选中字数统计
                 * @return {[type]} [description] null
                 */
                function showSelectionNum(position) {
                    var selectionNumDiv = $(document).find('.trs_ueditor_selectionNum');
                    selectionNumDiv.css('left', position.left + 'px');
                    selectionNumDiv.css('top', position.top + 'px');
                    selectionNumDiv.fadeIn('fast');
                }

                /**
                 * [hideSelectionNum methodname]显示选中字数统计
                 * @return {[type]} [description] null
                 */
                function hideSelectionNum() {
                    $(document).find('.trs_ueditor_selectionNum').fadeOut('fast');
                }

                /**
                 * [showSelectionNum methodname]显示选中字数统计
                 * @return {[type]} [description] null
                 */
                function selectionNumPop(event) {
                    var selectionStr = ue.selection.getText();
                    if (selectionStr.length !== 0) {
                        var selectionNumDiv = $(document).find('.trs_ueditor_selectionNum');
                        var position = {};

                        /* var e = event;
                        var sh = $window.pageYOffset || $window.document.documentElement.scrollTop || $window.document.body.scrollTop || 0;
                        position.left = (e.clientX - 40 < 0) ? e.clientX + 20 : e.clientX - 40;
                        position.top = (e.clientY - 40 < 0) ? e.clientY + sh + 20 : e.clientY + sh - 40;*/
                        selectionNumDiv.html('已选中' + selectionStr.replace(/&nbsp;/g, '').replace(/\u00a0/g, '').replace(/\u3000/g, '').replace(/\n/, '').length + '个字');
                        showSelectionNum(position);
                    } else {
                        hideSelectionNum();
                    }
                }
                ueditorService.compareLocalAndServe(scope, scope.type).then(function () {
                    scope.promise = $interval(localcache, ueditorService.asaveVersionIntervaltime());
                    ue.blur(); // 主动失去焦点
                }, function () {
                    ue.blur(); // 主动失去焦点
                });
                // MLFWEB-5014 修复全屏的bug
                ue.addListener('fullscreenchanged', function (type, bfullscreen) {
                    scope.infullscreen = bfullscreen;
                    var $iframeHolder = $('.edui-editor-iframeholder');
                    $iframeHolder.css('width', '100%');
                    // 全屏需要出滚动条
                    // $timeout(function() {
                    // });
                    //
                    var doc = $iframeHolder.find('iframe')[0].contentWindow.document;
                    doc.body.style.overflow = bfullscreen ? 'auto' : 'auto';
                    if (!bfullscreen) {
                        doc.body.style.height = 'initial';
                    }
                    $timeout(function () {
                        ue.selection.getRange().collapsed = true;
                        ue.selection.getRange().startOffset = ue.selection.getRange().endOffset;
                        ue.execCommand('inserthtml', '<trsfullscreen></trsfullscreen>');
                        var doms = doc.getElementsByTagName('trsfullscreen');

                        for (var index = 0; index < doms.length; index++) {
                            doms[index].parentNode.removeChild(doms[index]);
                        }

                        ue.fireEvent('contentChange');
                    });
                });
            });
            scope.$on('$destroy', function () {
                $interval.cancel(scope.promise); // 销毁定时事件
            });

            /**
             * [insertCommonContent description]插入默认信息
             * @return {[type]} [description]
             */
            function insertCommonContent() {
                if (scope.list.CONTENT) {return;} // 编辑页不进行默认填充
                var html = ueditorService.initializeManuscript();
                for (var i = 0; i < html.length; i++) {
                    ue.execCommand('insertHtml', html[i].content);
                    ue.execCommand('forecolor', html[i].color);
                    ue.fireEvent('contentchange');
                }
                ue.blur(); // 主动失去焦点
            }

            /**
             * [initStatus methodname]绑定数据和编辑器内容
             * @return {[type]} [description] null
             */
            function bindContent(promise) {
                if (promise) {
                    $timeout.cancel(promise);
                    promise = null;
                }
                promise = $timeout(function () {
                    scope.list.DOCWORDSCOUNT = ueditorService.getDOCWORDSCOUNT(ue)
                }, 500);
                return promise;
            }

            /**
             * [localcache methodname]本地保存
             * @return {[type]} [description] null
             */
            function localcache() {
                ueditorService.saveToLocal(scope.list.METADATAID, scope.type, ue.getContent(), scope.versionid);
            }

            /**
             * [timeCalc description] 时间计算
             * @return {[type]} [description]
             */
            function timeCalc() {
                var content = ueditorService.getTextContent(ue.getContent());
                var leadContent = getText(content, '【导语】');
                var mainContent = getText(content, '【正文】');
                var compileContent = getText(content, '【编后】');
                var leadSeconds = leadContent.length > 0 ? leadContent.length * 60 / scope.speed : 0;
                var mainSeconds = mainContent.length > 0 ? mainContent.length * 60 / scope.speed : 0;
                var compileSeconds = compileContent.length > 0 ? compileContent.length * 60 / scope.speed : 0;

                scope.list.CONTENTDURATION = timeTransform(mainSeconds);
                scope.list.INTRODUCERDURATION = timeTransform(leadSeconds);
                scope.list.EDITINGDURATION = timeTransform(compileSeconds);
                scope.list.TOTALDURATION = timeTransform(mainSeconds + leadSeconds + compileSeconds);
            }

            /**
             * [timeTransform description] 时间格式转化
             * @param  {[type]} time [description] 时间（秒）
             * @return {[type]}      [description]
             */
            function timeTransform(time) {
                var hours = Math.floor(time / (60 * 60)) < 10 ? '0' + Math.floor(time / (60 * 60)) : Math.floor(time / (60 * 60));
                var minutes = Math.floor((time - hours * 60 * 60) / 60) < 10 ? '0' + Math.floor((time - hours * 60 * 60) / 60) : Math.floor((time - hours * 60 * 60) / 60);
                var seconds = Math.round(time - hours * 60 * 60 - minutes * 60) < 10 ? '0' + Math.round(time - hours * 60 * 60 - minutes * 60) : Math.round(time - hours * 60 * 60 - minutes * 60);
                return hours + ':' + minutes + ':' + seconds;
            }

            /**
             * [getAllIndex description] 获取指定字符串的全部下标
             * @param  {[type]} str    [description] 内容
             * @param  {[type]} subStr [description] 指定的字符串
             * @return {[type]}        [description] 下标数组
             */
            function getAllIndex(str, subStr) {
                var positions = new Array();
                var pos = str.indexOf(subStr);
                while (pos > -1) {
                    // 每次搜索返回的位置被保存在数组positions中
                    positions.push(pos);
                    // 给indexOf()传递上一次的位置加1，确保了每次新搜索都从上一次找到的子字符串的后面开始
                    pos = str.indexOf(subStr, pos + 1);
                }
                return positions;
            }

            /**
             * [getMin description] 获取数组最小值
             * @param  {[type]} arr      [description] 数组
             * @param  {[type]} minFloor [description] 最小值下限
             * @return {[type]}          [description]
             */
            function getMin(arr, minFloor) {
                var dealedArr = [];
                arr.forEach(function (item, index) {
                    if (item > minFloor) {
                        dealedArr.push(item);
                    }
                });
                if (dealedArr.length == 0) {
                    return false;
                } else {
                    var min = dealedArr[0];
                    dealedArr.forEach(function (item) {
                        if (item < min) {
                            min = item;
                        }
                    });
                    return min;
                }
            }

            /**
             * [getText description] 全文本数据拼接
             * @param  {[type]} content  [description] 全文内容
             * @param  {[type]} strStart [description] 文本开始标识符
             * @return {[type]}          [description] 匹配的内容
             */
            function getText(content, strStart) {
                var indexArr = getAllIndex(content, strStart);
                var matchContent = '';
                for (var i = 0; i < indexArr.length; i++) {
                    var leadNextIndex = content.indexOf('【导语】', indexArr[i] + 4);
                    var mainNextIndex = content.indexOf('【正文】', indexArr[i] + 4);
                    var compileNextIndex = content.indexOf('【编后】', indexArr[i] + 4);
                    var nearNextIndex = getMin([leadNextIndex, mainNextIndex, compileNextIndex], -1);
                    if (nearNextIndex != false) {
                        matchContent += content.substring(indexArr[i] + 4, nearNextIndex);
                    } else {
                        matchContent += content.substring(indexArr[i] + 4);
                    }
                }
                return matchContent.replace(/\\n/g, '').replace(/\s+/g, '');
            }
            // 监控metadataid变化，并将正文更新进入本地版本
            ueditorService.watchMetadataidAndUpdateLocalVersion(scope, scope.type);

            /* 编辑器新增按钮开始*/
            var ueditorBtn = [];
            // 遍历按钮方法，实例化按钮，并返回按钮对象
            for (var i in ueditorForManuscriptBtnService) {
                ueditorForManuscriptBtnService[i](UE, scope, ue, i).then(function (btn) {
                    ueditorBtn[btn.index] = btn.obj;
                });
            }

            /* 编辑器新增按钮结束*/
            // 重写全屏方法
            ueditorService.rewriteFullScreen(UE, 60);
            // 编辑器中图片工具条
            // ueditorPlugIn.pictureToolbar(ue, scope, domUtils);
            // 视频的获取工具条
            // ueditorPlugIn.videoToolbar_(ue, scope);
            // ueditorPlugIn.audioToolbar(ue, scope);//音频的获取工具条
            scope.$on('$destroy', function () {
                ueditorService.destroyCommonUe(ue);
            });
            ueditorPlugIn.spaceIndent(ue, domUtils);
            ueditorPlugIn.outlinkPicDownload(ue, domUtils);
            ueditorPlugIn.fixContentInImageWrap(ue);
            ueditorPlugIn.fixPasteFromMicoWord(ue);
        }
    };
}]);
